import React, { useState, useEffect } from "react";
import "./TopFilter.css";
import { RiRefreshLine } from "react-icons/ri";
import { BsGrid } from "react-icons/bs";
import { TfiLayoutListThumb } from "react-icons/tfi";
import { MultiSelect } from "react-multi-select-component";
import { fetch_all_conditions, fetch_vital_alert_types } from "../../../services/rpm/Service";


function TopFilter({ onSwitchChange, onSearch, onRefresh, fetchAllUsers, getAlertStats, selected, setSelected }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [conditions, setConditions] = useState([]);
  const [selectedCondition, setSelectedCondition] = useState("");
  const [vitalAlertTypes, setVitalAlertTypes] = useState([]);
  const [gender, setGender] = useState("");
  const [ageGroup, setAgeGroup] = useState("");
  // Handle the switch change and notify the parent component
  const handleSwitchChange = (event) => {
    onSwitchChange(event.target.checked); // Pass the switch state to parent
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Handle search button click
  const handleSearch = () => {
    if (onSearch) {
      // onSearch(searchTerm);
      fetchAllUsers(1, 12, searchTerm, selectedCondition, selected, gender, ageGroup);
      getAlertStats(searchTerm, selectedCondition, selected, gender, ageGroup);
    }
  };

  // Handle refresh button click
  const handleRefresh = () => {
    setSearchTerm(""); // Clear search term
    if (onRefresh) {
      onRefresh();
    }
  };

  useEffect(() => {
    getConditions();
    getVitalAlertTypes();
  }, []);


  function getConditions() {
    fetch_all_conditions().then((response) => {
      setConditions(response.data.data?.conditions);
    }).catch((error) => {
      console.log(error);
    });
  }

  function getVitalAlertTypes() {
    fetch_vital_alert_types().then((response) => {
      setVitalAlertTypes(response.data.data?.data);
    }).catch((error) => {
      console.log(error);
    });
  }

  return (
    
      <div className="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-w-full tw-mt-2">
      <div className="tw-w-1/6 mb-3 pe-0">
          <label htmlFor="allInformation" className="form-label sub-title">
            Search
          </label>
          <div className="form-group" style={{ width: "100%" }}>
            <input
              type="text"
              id="searchInput"
              placeholder="Search By Name, Member ID"
              className="form-control input-field-ui ps-5 tw-py-2.5"
              value={searchTerm}
              onChange={handleSearchChange}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()}
            />
            <img
              src="https://storage.googleapis.com/ksabupatest/2024/09/24/ljce8/fac3csq13o.png"
              className="input-icon-seacrh"
              alt=""
            />
          </div>
        </div>
        <div className="tw-w-1/6 mb-3 pe-0">
          <label htmlFor="allInformation" className="form-label sub-title">
            Care Program State
          </label>
          <select
            className="form-select frame-select"
            id="allInformation"
            aria-label="Default select example"
            value={selectedCondition}
            onChange={(e) => setSelectedCondition(e.target.value)}
          >
            <option defaultValue={""}>All Selected</option>
            <option value="" disabled>
              Select Condition
            </option>
            {conditions.map((condition) => (
              <option value={condition.conditionId}>{condition.conditionName}</option>
            ))}
          </select>
        </div>

        <div className="tw-w-1/6 mb-3 pe-0">
          <label htmlFor="allInformation" className="form-label sub-title">
            Filter Vital Alerts
          </label>
          <MultiSelect
            options={vitalAlertTypes}
            value={selected}
            onChange={setSelected}
            labelledBy="Select"
            hasSelectAll={true}
            overrideStrings={{
              selectSomeItems: "Filter by vital type...",
              allItemsAreSelected: "All vitals selected",
              selectAll: "Select All",
              search: "Search",
            }}
            className="tw-py-1 tw-px-2 form-select input-field-ui"
          />
        </div>

        <div className="tw-w-1/6 mb-3 pe-0">
          <label htmlFor="genderSelect" className="form-label sub-title">
            Gender
          </label>
          <select
            className="form-select frame-select"
            id="genderSelect"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
          >
            <option value="" disabled>Select Gender</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
          </select>
        </div>

        <div className="tw-w-1/6 mb-3 pe-0">
          <label htmlFor="ageGroupSelect" className="form-label sub-title">
            Age Group
          </label>
          <select
            className="form-select frame-select"
            id="ageGroupSelect"
            value={ageGroup}
            onChange={(e) => setAgeGroup(e.target.value)}
          >
            <option value="" disabled>Select Age Group</option>
            <option value="0-12">0–12</option>
            <option value="13-18">13–18</option>
            <option value="19-35">19–35</option>
            <option value="36-50">36–50</option>
            <option value="51-65">51–65</option>
            <option value="66-80">66–80</option>
            <option value="80+">80 and above</option>
          </select>
        </div>

        
        <div className="tw-w-1/6 tw-flex tw-flex-row tw-gap-2 tw-items-center tw-mt-4 px-1 ">
          <button
            className="btn btn-primary clear-search-btn"
            onClick={handleSearch}
          >
            Search
          </button>
          <button
            type="button"
            className="btn clear-search-btn tw-ml-2"
            onClick={handleRefresh}
          >
            <RiRefreshLine />
          </button>
          <div className="form-switch tw-flex tw-flex-row items-center tw-gap-2 tw-p-0">
            <BsGrid className="tw-mt-0.5" />
                <input
                  className="form-check-input mx-0 tw-mt-0"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  onChange={handleSwitchChange} // Update the switch state on change
                />
              <TfiLayoutListThumb className="tw-mt-0.5" />
          </div>
        </div>
      </div>
    
  );
}

export default TopFilter;
